import { Box, Button, Typography } from "@mui/material";
import Bg from '../../assets/landing_page/bg/1.png'
// import Txt from '../../assets/landing_page/Scribbles/Highlight 14.png'
import PlanShare from '../../assets/landing_page/PlanShare.AI.gif'
import { Link as RouterLink } from 'react-router-dom';
import { LeftTextHighlight, TopTextHighlight } from "../../utils/icon/Landing-Page/Icon";

export const FirstPage = () => {
    return (
        <Box sx={{ minHeight: '100vh', height: '100%', display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '80%' }}>
                <Box sx={{ textAlign: 'center', mt: 10 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', pr: 73 }}>
                        <TopTextHighlight />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <LeftTextHighlight />
                        <Typography sx={{ fontSize: '72px', color: '#040815', fontWeight: '700' }}>Transform Your Project<br /> Management Experience.</Typography>
                    </Box>
                    <Typography sx={{ fontSize: '24px', color: '#474747', fontWeight: '500' }}>Augment your project with our robust, secure and scalable product. <br />
                        Streamline your process and achieve new levels of efficiency.</Typography>
                    <Box sx={{ my: 4 }}>
                        <RouterLink to="/Reg" style={{ textDecoration: 'none' }}>
                            <Button sx={{ color: '#fff', background: '#FF2800', height: '50px', mx: '10px', textTransform: 'capitalize', '&:hover': { background: '#FF280099' }, px: 3 }}>Get Started</Button>
                        </RouterLink>
                        <RouterLink to="/Login" style={{ textDecoration: 'none' }}>
                            <Button disableRipple sx={{ color: '#474747', height: '50px', border: '0.6px solid #474747', fontWeight: '500', fontSize: '18px', mx: '10px', textTransform: 'capitalize', px: 3 }}>Sign In</Button>
                        </RouterLink >
                    </Box>
                    <img src={PlanShare} alt="" style={{ border: '5px solid #474747', height: 'auto', width: '100%', borderRadius: '11.79px', marginBottom: '5rem' }} />
                </Box>
            </Box>
        </Box>
    );
}